import BottomNavigation from './BottomNavigation'
export default BottomNavigation
